import { render } from "./comparison-list-small.vue?vue&type=template&id=2f635ac9"
import script from "./comparison-list-small.vue?vue&type=script&lang=js"
export * from "./comparison-list-small.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__